<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<h1 style="padding-top:80px;">Acknowledgment</h1><br/>
<p style="text-indent:0px;">Dad – for showing me the meaning of determination.</p>
<p style="text-indent:0px;">Mam – for showing me the importance of being happy.</p>
<p style="text-indent:0px;">Connor – for his impeccable taste and providing a bridge to strong artistic expression.</p>
<p style="text-indent:0px;">The DMLK Boys – for being my chosen family alongside my given one.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?118ac9de